import { render } from "./GrafanaFrame.vue?vue&type=template&id=61b5554d&scoped=true"
import script from "./GrafanaFrame.vue?vue&type=script&lang=js"
export * from "./GrafanaFrame.vue?vue&type=script&lang=js"

import "./GrafanaFrame.vue?vue&type=style&index=0&id=61b5554d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b5554d"]])

export default __exports__